'use strict';

angular.module('licensure.services')
    .factory('ComplaintMonitoring', ['$http', '$q', function ($http, $q) {
    	return {
    		save: function (complaint_action) {
    		    var d = $q.defer();

    			var method = 'POST';
    			var url = apiLocation + '/api/ComplaintMonitoring/';
    			if (!isUndefined(complaint_action.id)) {
    				method = 'PUT'
    				url += complaint_action.id
    			}

    			$http({
    				method: method,
    				url: url,
    				data: {
    					complaint_action: complaint_action
    				}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

    			return d.promise;
    		},

    		delete: function (id) {
    			var d = $q.defer();

    			$http.delete(apiLocation + '/api/ComplaintMonitoring/' + id, {
    				params: {

    				}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

    			return d.promise;
    		},
    	}
    }])
;